var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTrashCan = function SvgTrashCan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 13.985 14.533"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 3.3h8.391v9.909H2.8Zm3.3-1.979h1.787l.233.661H5.865ZM5.09 0l-.7 1.982H0V3.3h1.4v11.23h11.186V3.3h1.4V1.982H9.594L8.895 0Z",
    fill: "#fff"
  })));
};

export default SvgTrashCan;